import { getDownloadHref } from '../../services/downloads/get-download-href';
import qualityEvents from '../../services/quality-events/quality-events';
import axios from '../axios';
import { storageKeys } from '../browser-storage/storage-keys';
import isInteractiveStandaloneMaterial from '../interactive/is-interactive-standalone-material';
import { getUserData } from '../user/user';

type GetFreeMaterialOptions = {
    materialInfo: Material;
    skipDownload?: boolean;
    searchRequestId?: string;
};

const getFreeMaterial = async (
    id: number,
    { materialInfo, skipDownload = false, searchRequestId }: GetFreeMaterialOptions
): Promise<void> => {
    const email =
        getUserData().profileDetails.invoiceDetails.clientEmail ||
        window.storage.getItem(storageKeys.email.freeMaterialDownloadUserEmail) ||
        '';

    const r = await axios.get(`v1/order/free-material/request/${id}`, { params: { directLink: true, email } });
    const { token } = r.data.items;
    const isStandalone = isInteractiveStandaloneMaterial(materialInfo);
    const isSources = Boolean(materialInfo.materialFiles?.find((m) => m.type === 'sources'));

    if ((!isStandalone || isSources) && !skipDownload) {
        await getDownloadHref({ id: token, isFree: true });
    }

    await qualityEvents.general.freeDownload(materialInfo, searchRequestId);
};

export default getFreeMaterial;
